import type {
	Components,
} from '@mui/material'
import {
	tabClasses,
} from '@mui/material'

export const materialUITabsTheme: {
	components: Components
} = {
	components: {
		MuiTabs: {
			styleOverrides: {
				root: {
					height:       '2.25rem',
					minHeight:     '0',
					background:   'none',
				},
				indicator: {
					height:          '3px',
					backgroundColor: 'var(--primary-color)',
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					padding:       'var(--base-spacing-1)',
					textTransform: 'capitalize',
					color:         'var(--secondary-hint-color)',
					fontWeight:    '600',
					height:        '2.25rem',
					minHeight:     '0',
					fontSize:      '0.75rem',

					[`&.${tabClasses.selected}`]: {
						color: 'var(--primary-color)',
					},
				},
			},
		},
	},
}
